/**
 * Created by rickborst on 14/02/2017.
 */

import {connect} from 'react-redux';

import Landing from 'components/pages/landing/landing.jsx';
import {
    processRedirect
} from 'store/actions/payment';
import {
    ActiveViewStatuses,
    setActiveViewStatus
} from 'store/actions/viewtree';
import {getDevice} from 'store/actions/device';
import {
    attemptSessionRefresh
} from 'store/actions/session';
import {
    loadLandingPage
} from 'store/actions/landing';

/**
 * Map states to props object.
 *
 * @param {Object} state - State of the app.
 * @returns {Object} Mapped states.
 */
const mapStateToProps = (state) => ({
    ...state,
    isLoggedIn: state.session.loggedIn,
    hasActiveSubscription: !!(
        state.paymentDetails.type
        && state.paymentDetails.endDate
    )
}),

/**
 * Map dispatch to props container object.
 *
 * @param {Function} dispatch - Dispatcher function of the redux store.
 * @returns {Object} Map of actions connections.
 */
mapDispatchToProps = (dispatch) => ({

    processRedirect: (redirectParams, redirectUrl) => {
        return dispatch(processRedirect(redirectParams, redirectUrl));
    },

    removeLoader: () => {
        return dispatch(setActiveViewStatus(ActiveViewStatuses.READY));
    },
    getDevice: () => {
        return dispatch(getDevice());
    },
    attemptSessionRefresh: (force = false) => {
        return dispatch(attemptSessionRefresh(true, true, force));
    },
    loadLandingPage: () => {
        return dispatch(loadLandingPage());
    },
    showLoader: () => {
        return dispatch(setActiveViewStatus(ActiveViewStatuses.LOADING));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Landing);


// WEBPACK FOOTER //
// ./src/js/containers/pages/landing.js